<template>
  <div>
    <!-- <custom-header title="部门与员工" > -->
      <!-- 使用具名插槽 -->
      <!-- <template slot="right">

      </template> -->
    <!-- </custom-header> -->
    <Breadcrumb></Breadcrumb>
    <ak-model-filter-card model="store" @search="search" @reset="reset" :value="where"/>
    <ak-model-card model="store" :filters="filters" :page.sync="page" :action="action" tableSize="small" title="门店管理" ref="management" />

  </div>
</template>
<script>
import Breadcrumb from '../../components/tools/Breadcrumb.vue'
import createStore from './component/createStore'
import downloadZip from '../../assets/js/downloazip.js'
// import auditCreateStore from './component/auditCreateStore'
import tkModelExporter from '../../core/model/component/export/tkModelExporter.vue'
import { mapState } from 'vuex'
import store from '../../store/index'
import qs from 'qs'
export default {
  components: {
    Breadcrumb
  },
  data () {
    return {
      filters: {
        isDelete: { $ne: true }
      },
      page: Number(this.$route.query.page) || 1,
      action: {
        export: {
          type: 'list',
          text: '导出',
          permission: 'exportStoreModel',
          // component: 'akModelExporter',
          component: tkModelExporter,
          title: '门店列表'
        },
        exportCode: {
          type: 'list',
          // icon: 'export',
          text: '导出二维码',
          permission: 'exportCodeStoreModel',
          callback: async ({ record, vm, modelName }) => {
            try {
              vm.$loading.show()
              let where = {}
              if (this.$store.state.user.level === '3') {
                // 代理商
                where.agent = this.$store.state.user.objectId
              } else if (this.$store.state.user.level === '4') {
                // 业务员
                where.agent = this.$store.state.user.agent
              } else if (this.$store.state.user.level === '1') {
                // 战区
                where.warZone = this.$store.state.user.department
              } else if (this.$store.state.user.level === '2') {
                // 大区
                where.regional = this.$store.state.user.department
              }
              let page = 0
              let pageCount = 200
              let arr = []
              let imgDataArray = []
              while (true) {
                let res = await vm.$modelAjax.getList(modelName, {
                  params: {
                    limit: pageCount,
                    skip: page * pageCount,
                    keys: 'appletDisplayName,number,qrcodePoster',
                    order: '-createdAt',
                    where: {
                      QRcode: {
                        $exists: true
                      },
                      isDelete: {
                        $ne: true
                      },
                      ...where
                    }
                  }
                })
                arr = [...arr, ...res]
                page++
                if (res.length < pageCount) break
              }
              imgDataArray = arr.map(s => { return { url: s.qrcodePoster, name: `${s.number}+${s.appletDisplayName}` + '.png' } })
              console.log(imgDataArray, 'imgDataArray')
              const zipFileName = '门店二维码'
              downloadZip(zipFileName, imgDataArray)
              vm.$loading.hide()
              vm.$notification.success({
                message: '操作成功',
                description: '二维码导出完成'
              })
            } catch (e) {
              console.log(e, 'ee')
              vm.$loading.hide()
              vm.$notification.error({
                message: '操作失败',
                description: '二维码导出失败'
              })
            }
          }
        },
        create: {
          title: '新增门店',
          permission: 'createStoreModel',
          component: createStore,
          tag: 'create'
        },
        edit: {
          title: '编辑门店',
          permission: 'editStoreModel',
          hidden: ({ record }) => {
            if (record && record.status === 'review') return true
            if (record && record.status === 'unpass' && store.state.user.level !== '3') return true
            return false
          },
          component: createStore,
          tag: 'edit'
        },
        view: {
          type: 'row',
          text: '查看',
          permission: 'viewStoreModel',
          callback: async ({ record, vm, className }) => {
            vm.$router.push({ path: '/store/storeDetail', query: { id: record.objectId } })
          },
          hidden: () => {
            return false
          }
        },
        addStock: {
          type: 'row',
          text: '门店铺货',
          permission: 'inventoryStoreModel',
          hidden: ({ record }) => {
            if (record && record.status !== 'pass') return true
            return false
          },
          callback: async ({ record, vm, className }) => {
            vm.$router.push({ path: '/store/storeDetail', query: { id: record.objectId, index: 1 } })
          }
          // component: createDistributionStock
        },
        disable: {
          type: 'row',
          text: '禁用',
          permission: 'disableStoreModel',
          hidden: ({ record }) => {
            if (record && record.status !== 'pass') return true
            return record && record.isDisabled
          },
          callback: async ({ record, vm, modelName }) => { // 点击按钮后触发的callback回调，参数中的 record代表被点击行的数据，vm为vue实例
            await vm.confirm('警告', '您确定要禁用该门店吗?')
            await vm.$tkParse.put(`/classes/store/${record.objectId}`, {})
            let rs = await vm.$tkParse.put(`/classes/store/${record.objectId}`, {
              isDisabled: true
            }).catch(() => {
              vm.$notification['error']({
                message: '网络错误',
                description: '禁用失败'
              })
            })
            if (rs) {
              vm.$notification['success']({
                message: '操作成功',
                description: '禁用成功'
              })
              vm.refresh()
            }
          }
        },
        enable: {
          type: 'row',
          text: '启用',
          permission: 'enableStoreModel',
          hidden: ({ record }) => {
            if (record && record.status !== 'pass') return true
            return record && !record.isDisabled
          },
          callback: async ({ record, vm, modelName }) => { // 点击按钮后触发的callback回调，参数中的 record代表被点击行的数据，vm为vue实例
            await vm.confirm('警告', '您确定要启用该门店吗?')
            let rs = await vm.$tkParse.put(`/classes/store/${record.objectId}`, {
              isDisabled: false
            }).catch(() => {
              vm.$notification['error']({
                message: '网络错误',
                description: '禁用失败'
              })
            })
            if (rs) {
              vm.$notification['success']({
                message: '操作成功',
                description: '禁用成功'
              })
              vm.refresh()
            }
          }
        },
        empowerService: {
          type: 'row',
          text: '授予服务权限',
          permission: 'empowerService',
          hidden: ({ record }) => {
            if (record && record.status !== 'pass') return true
            return record && record.haveService
          },
          callback: async ({ record, vm, modelName }) => { // 点击按钮后触发的callback回调，参数中的 record代表被点击行的数据，vm为vue实例
            await vm.confirm('警告', '您确定要授予该门店服务权限吗?')
            let rs = await vm.$tkParse.put(`/classes/store/${record.objectId}`, {
              haveService: true
            }).catch(() => {
              vm.$notification['error']({
                message: '网络错误',
                description: '禁用失败'
              })
            })
            if (rs) {
              vm.$notification['success']({
                message: '操作成功',
                description: '授权成功'
              })
              vm.refresh()
            }
          }
        },
        cancelEmpowerService: {
          type: 'row',
          text: '取消服务权限',
          permission: 'cancelEmpowerService',
          hidden: ({ record }) => {
            if (record && record.status !== 'pass') return true
            return record && !record.haveService
          },
          callback: async ({ record, vm, modelName }) => { // 点击按钮后触发的callback回调，参数中的 record代表被点击行的数据，vm为vue实例
            await vm.confirm('警告', '您确定要取消该门店服务权限吗?')
            let rs = await vm.$tkParse.put(`/classes/store/${record.objectId}`, {
              haveService: false
            }).catch(() => {
              vm.$notification['error']({
                message: '网络错误',
                description: '禁用失败'
              })
            })
            if (rs) {
              vm.$notification['success']({
                message: '操作成功',
                description: '取消成功'
              })
              vm.refresh()
            }
          }
        }
        // audit: {
        //   type: 'row',
        //   text: '审核',
        //   permission: 'auditStoreModel',
        //   hidden: ({ record }) => {
        //     return record && record.status !== 'review'
        //   },
        //   callback: async ({ record, vm, className }) => {
        //     vm.$router.push({ path: '/store/storeDetail', query: { id: record.objectId } })
        //   }
        //   // component: auditCreateStore
        // }
      }
    }
  },
  watch: {
    page (val) {
      this.reRoute()
      // this.$router.replace({
      //   path: this.$route.path,
      //   query: Object.assign({}, this.$route.query, { page: this.page })
      // })
    }
    // '$route.query': {
    //   handler (val) {
    //     if (!val) {
    //       this.filters = {
    //         isDelete: { $ne: true }
    //       }
    //       this.setFilters()
    //       this.reRoute()
    //     }
    //   },
    //   deep: true
    // }
  },
  computed: {
    ...mapState(['user']),
    where () {
      let where = { ...this.filters }
      for (let i in where) {
        if (where[i].$regex) {
          where[i] = where[i].$regex
        }
      }
      return where
    }
  },
  beforeDestroy () {
    this.$store.commit('setDepartment', null)
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.setFilters()
      this.filters = {
        ...this.filters,
        ...this.$route.query.filters ? qs.parse(this.$route.query.filters) : {}
      }
    },
    search (filters) {
      // filters是组件自动生成的where搜索参数
      this.page = 1
      console.log(filters, 'ssss')
      this.filters = { isDelete: { $ne: true }, ...filters }
      this.reRoute()
    },
    reset () {
      this.page = 1
      this.filters = { isDelete: { $ne: true } }
      this.setFilters()
      this.reRoute()
    },
    setFilters () {
      if (this.$store.state.user.level === '3') {
        // 代理商
        this.filters.agent = this.$store.state.user.objectId
      } else if (this.$store.state.user.level === '4') {
        // 业务员
        this.filters.agent = this.$store.state.user.agent
      } else if (this.$store.state.user.level === '1') {
        // 战区
        this.filters.warZone = this.$store.state.user.department
      } else if (this.$store.state.user.level === '2') {
        // 大区
        this.filters.regional = this.$store.state.user.department
      }
    },
    reRoute () {
      let query = {}
      if (Number(this.page) > 1) query.page = this.page
      if (this.filters && Object.keys(this.filters).length > 0) query.filters = qs.stringify(this.filters)
      console.log(query, 'queryqueryqueryqueryquery')
      this.$router.replace({
        path: this.$route.path,
        query: query
      }).catch(() => {})
    }
  }
}
</script>
<style lang="scss" scoped>
.amdin_role_card{
  height: 152px;
  color: #152137;
}
</style>
